import {
    CLUSTER_DATA,
    CONFIG_CONTENT,
    CONNECTION_STATUS,
    GET_VERSION,
    JOB_LIST,
    LOG_FILES,
    LOG_SNIPPET,
    REDIRECT,
    SELECT_SCHEMA,
    SET_OPERATOR,
    SELECT_UI_SCHEMA,
    SET_LOG_LEVEL,
    API_KEY,
    COMP_PERM,
    ROLES_DATA,
    COMP_PERM_STRING,
    RESOURCES_DATA,
    SERVER_STATE,
    VALID_USER,
    KEY_GENERATE,
    IS_VALID_KEY,
    IS_CONFIG_USER,
    BACKEND_JOBS,
    USER_ROLE_LIST,
    APP_CONFIG_DATA,
    USER_DATA,
    GET_API_KEY,
    GET_ALL_USER,
    GET_ALL_SYS_CONFIG,
    GET_LIVE_JOB_LIST,
    DATA_QUALITY_LOADING,
    SET_DATA_QUALITY_TOTAL_RECORD,
    GET_DP_RIGS_LIST,
    GET_DP_DP_LIST,
    GET_DP_BUNIT_LIST,
    GET_FINISH_JOB_LIST,
    GET_FINISH_JOB_TOTAL_RECORDS,
    GET_LIVE_JOB_TOTAL_RECORDS,
    GET_DATA_QUALITY_CHART_DATA,
    GET_DATA_QUALITY_ASSET_ID,
    GET_DATA_QUALITY_TIME,
    GET_ALL_USER_TOTAL_RECORD,
    CHANGE_PASSWORD,
    LOADING_ON,
    GET_ALL_ROLES,
    GET_ALL_ROLES_DATA_RECORD,
    VUSER_ROLE_LIST_TOTALRECORDS,
    GET_ALL_DATA_PROVIDER_TOTAL_RECORD,
    APP_CONFIG_DATA_TOTALRECORDS,
    DOWNLOAD_JOB,
    GET_ALL_LICENSE_DATA,
    GET_ALL_LICENSE_DATA_RECORD,
    TEMPLATE_SUCCESSFULLY,
    CLUSTER_DATA_TEMPLATE,
    GET_NODE_INFO_LIST,
    GET_NODE_INFO_DATA,
    GET_TOTAL_RECORD_NODE_INFO,
    IS_SUCCESS
} from "../constants/action-types";
import axios from "axios";
import { loadingOff, loadingOn } from "../utils";
import dqSchema from "../../Assets/Schemas/DQ_JSON_schema.json";
import oeYhSchema from "../../Assets/Schemas/oe_yh_schema.json";
import oeCsvSchema from "../../Assets/Schemas/oe_csv_schema.json";
import pySchema from "../../Assets/Schemas/py_schema.json";
import aoSchema from "../../Assets/Schemas/ao_schema.json";
import dqUiSchema from "./../../Assets/UiSchemas/dqUiSchema.json";
import oeYhUiSchema from "./../../Assets/UiSchemas/oeYhUiSchema.json";
import oeCsvUiSchema from "./../../Assets/UiSchemas/oeCsvUiSchema.json";
import pyUiSchema from "./../../Assets/UiSchemas/pyUiSchema.json";
import aoUiSchema from "./../../Assets/UiSchemas/aoUiSchema.json";
import dqData from "./../../Assets/DefaultData/dq_data.json";
import oeCsvData from "./../../Assets/DefaultData/oe_csv_data.json";
import oeYhData from "./../../Assets/DefaultData/oe_yh_data.json";
import pyData from "./../../Assets/DefaultData/py_data.json";
import { validationForRoles } from "./actionPerform";
import { errorMsg, infoMsg, successMsg } from "../errorMsg/ErrorMsg";

// const port = "http://192.168.2.132:8081"
const port = 'http://192.168.1.128:8081'
// const port = "http://192.168.3.41:8081"
// const port = "http://192.168.3.41:8084"
// const port = "http://192.168.2.103:8081"

// const port = process.env.REACT_APP_API_URL
// const port = "http://192.168.3.46:8081"
// const  = "port"
//  ${getState().data.apiUrl.address}
// const port = 'http://veras-chevron.sigmastream.com:8081'

const headers = `${sessionStorage.getItem('header')}`


export const insertTemplate = (combineData) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/jobs/createTemplate`, combineData, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {

            if (res.data.Result == "OK") {
                successMsg('Successfully save Data')
            } else {
                errorMsg("Something is wrong!")
            }
            dispatch(loadingOff())
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get All Sys Config")
        });
}

export const getAllRoles = (pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/role/get`, { params: { sessionUser: sessionStorage.getItem('username'), pageSize: pageSize, pageNumber: pageNumber, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Message !== undefined && res.data.Result === 'OK') {
                dispatch({
                    type: ROLES_DATA,
                    payload: res.data.Message
                })
                dispatch({
                    type: GET_ALL_ROLES_DATA_RECORD,
                    payload: res.data.totalRecords
                })
                dispatch({
                    type: GET_ALL_ROLES,
                    payload: res.data.Roles
                })
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Role Get")
        });
}

export const getAllLicenseData = (pagination, columnName, orderBy) => (dispatch, getState) => {
    axios
        .post(
            `${getState().data.apiUrl.address}/veras/licence/get`,
            { pageNumber: pagination.pageNumber, pageSize: 1000, columnName: "", orderBy: "desc" },
            {
                params: {
                    sessionUser: sessionStorage.getItem("username"),
                    authorization: sessionStorage.getItem("header"),
                },
            }
        )
        .then((res) => {
            if (res.data.Message !== undefined && res.data.Result === 'OK') {
                dispatch({
                    type: GET_ALL_LICENSE_DATA,
                    payload: res.data.Message
                })
                dispatch({
                    type: GET_ALL_LICENSE_DATA_RECORD,
                    payload: res.data.totalRecords
                })
            }
        })
        .catch((error) => {
            dispatch(loadingOff());
            errorMsg("Network Issues Please wait...", "License Get");
        });
};

export const getDownloadJobs = (jobsData) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/jobs/download`, jobsData, {
            params: {
                sessionUser: sessionStorage.getItem("username"),
                authorization: sessionStorage.getItem("header"),
            },
            responseType: "arraybuffer",
        })
        .then((response) => {

            dispatch(loadingOff());
            const contentLength = response.headers['content-length'];
            if (contentLength > 0) {
                const blob = new Blob([response.data], { type: "application/octet-stream" });
                const downloadUrl = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = "Folder.zip";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                //   dispatch({
                //     type: DOWNLOAD_JOB,
                //     payload: response.data,
                //   });
            } else {
                errorMsg("Log is not available.", "Download Error");
            }
        })
        .catch((err) => {
            dispatch(loadingOff());
            errorMsg("Network Issues. Please try again later.", "Download Error");
        });
};

export const getApiKey = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/user/getKey`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: GET_API_KEY,
                    payload: res.data.Message
                })
            } else {
                errorMsg(res.data.Error, "Get User API KEY")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get User API KEY")
        });
}

export const deleteUser = (form, pageSize, pageNumber) => (dispatch, getState) => {

    axios
        .delete(`${getState().data.apiUrl.address}/veras/user/delete`, { params: { sessionUser: sessionStorage.getItem('username'), username: form.username, id: form.id, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch(getAllUser(pageSize, pageNumber));
                successMsg(res.data.Message, 'User Data')
            } else {
                errorMsg(res.data.Error, "User Data")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "User Data")
        });
}

export const getAllUser = (pageSize, pageIndex) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/user/getAllUser`, { params: { sessionUser: sessionStorage.getItem('username'), pageSize: pageSize, pageNumber: pageIndex, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: GET_ALL_USER,
                    payload: res.data.Message
                })
                dispatch({
                    type: GET_ALL_USER_TOTAL_RECORD,
                    payload: res.data.totalRecords,
                });
            } else {
                errorMsg(res.data.Error, "Get All User")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get All User")
        });
}



export const getAllSysConfig = (pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/sysConfig/getSysInfo`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header'), pageSize: pageSize, pageNumber: pageNumber } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: GET_ALL_SYS_CONFIG,
                    payload: res.data.Message
                })
                dispatch({
                    type: GET_ALL_DATA_PROVIDER_TOTAL_RECORD,
                    payload: res.data.totalRecords
                })
            } else {
                errorMsg(res.data.Error, "Get All Sys Config")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get All Sys Config")
        });
}

export const setAppConfig = (form) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/appConfig/set`, {}, { params: { ...form, sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                successMsg(res.data.Message, 'Application Configuration')
            } else {
                errorMsg(res.data.Error, "Application Configuration")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Application Configuration")
        });
}

export const resumeJob = (job, action) => (dispatch, getState) => {
    axios
        .put(`${getState().data.apiUrl.address}/veras/jobs/updateJob`, job, { sessionUser: sessionStorage.getItem('username'), params: { action: action, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                successMsg(res.data.Message, 'Application Configuration')
                dispatch(getLiveJobList('active', { pageNumber: 1, pageSize: 10 }));
            } else {
                errorMsg(res.data.Message, "Application Configuration")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Application Configuration")
        });
}

// export const stopJob = (job) => (dispatch, getState) => {
//     axios
//         .put(`${getState().data.apiUrl.address}/veras/jobs/stop`, {}, { params: { jobName: job, "authorization": sessionStorage.getItem('header') } })
//         .then((res) => {
//             dispatch(loadingOff())
//             if (res.data.Error === undefined && res.data.Result === 'OK') {
//                 successMsg(res.data.Message, 'Application Configuration')
//                 dispatch(getLiveJobList());
//             } else {
//                 errorMsg(res.data.Message, "Application Configuration")
//             }
//         }).catch((err) => {
//             dispatch(loadingOff())
//             errorMsg("Network Issues Please wait...", "Application Configuration")
//         });
// }

export const getJobData = (job, isActive) => (dispatch, getState) => {
    axios
        .put(`${getState().data.apiUrl.address}/veras/jobs/getJobData`, {}, { params: { job, isActive: isActive, sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                successMsg(res.data.Message, 'Application Configuration')
                dispatch(getLiveJobList('active', { pageNumber: 0, pageSize: 10 }));
            } else {
                errorMsg(res.data.Message, "Application Configuration")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Application Configuration")
        });
}

export const setSysConfig = (form, pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/sysConfig/set`, form, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === 'Error') {
                infoMsg(res.data.Message)
            }
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                // dispatch({
                //     type: RESOURCES_DATA,
                //     payload: 
                // })

                successMsg(res.data.Message, "System Config")
                dispatch(getValidateKey());
                dispatch(getAllSysConfig(pageSize, pageNumber));
            } else if (res.data.Error === undefined && res.data.Result === 'isExist') {
                infoMsg(res.data.Message, "System Config")
            } else {
                // errorMsg(res.data.Message, "System Config")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "System Config")
        });
}

export const deleteAppConfig = (form) => (dispatch, getState) => {
    // axios
    // .post(`${getState().data.apiUrl.address}/veras/sysConfig/setInfo`, form )
    //     .then((res) => {
    //         if(res.data.Error === undefined && res.data.Result === 'OK') {
    //             dispatch({
    //                 type: RESOURCES_DATA,
    //                 payload: res.data.Message
    //             })
    //             successMsg("Backend Jobs save successfully", "Backend Jobs")
    //         } else {
    //             errorMsg(res.data.Message, "Backend Jobs")
    //         }
    //         }).catch((err) => {
    //             errorMsg("Network Issues Please wait...", "Backend Jobs")
    //         });
}

export const updateAppConfig = (row, pageSize, pageNumber) => (dispatch, getState) => {

    axios
        .put(`${getState().data.apiUrl.address}/veras/sysConfig/setAppInfo`, { propertyKey: row._valuesCache.propertykey, propertyValue: row._valuesCache.propertyvalue }, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                // dispatch({
                //     type: RESOURCES_DATA,
                //     payload: res.data.Message
                // })           
                dispatch(getAllAppConfig(pageSize, pageNumber));
                successMsg("Application Configuration save successfully", "App Config")
            } else {
                errorMsg(res.data.Message, "App Config")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "App Config")
        });
}

export const setBackendJobs = (form) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/sysConfig/setInfo`, form, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: RESOURCES_DATA,
                    payload: res.data.Message
                })
                dispatch(getAllJobs());
                successMsg("Backend Jobs save successfully", "Backend Jobs")
            } else {
                errorMsg(res.data.Message, "Backend Jobs")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Backend Jobs")
        });
}

export const getAllJobs = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/sysConfig/getServer`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: RESOURCES_DATA,
                    payload: res.data.Message
                })
                // successMsg("Backend Jobs save successfully", "Backend Jobs")
            } else {
                errorMsg(res.data.Message, "Backend Jobs")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Backend Jobs")
        });
}

export const getAppConfig = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/sysConfig/setInfo`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: BACKEND_JOBS,
                    payload: res.data.Message
                })
            } else {
                errorMsg(res.data.Message, "Application Config")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Application Config")
        });
}

export const setCreateJobs = (file) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/jobs/uploadJobs`, file, {
            params: { file: file, sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((res) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Validate");
            // console.log(err);
            // cogoToast.error("Something went wrong.",{
            //     position: 'bottom-right'
            //   });
        });

}

export const getAllAppConfig = (pageSize, pageNumebr) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/sysConfig/getAppConfig`, { headers: { "Authorization": headers }, params: { sessionUser: sessionStorage.getItem('username') !== undefined ? sessionStorage.getItem('username') : '', pageSize: pageSize, pageNumber: pageNumebr, "authorization": sessionStorage.getItem('header') !== undefined ? sessionStorage.getItem('header') : "" } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error === undefined && res.data.Result === 'OK') {
                dispatch({
                    type: APP_CONFIG_DATA,
                    payload: res.data.Message
                })
                dispatch({
                    type: APP_CONFIG_DATA_TOTALRECORDS,
                    payload: res.data.totalRecords
                })
            } else {
                errorMsg(res.data.Message, "Application Config")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Application Config")
        });

}



export const getAllResouces = (pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/resource/get`, { params: { sessionUser: sessionStorage.getItem('username'), pageSize: pageSize, pageNumber: pageNumber, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Message !== undefined) {
                dispatch({
                    type: RESOURCES_DATA,
                    payload: res.data.Message
                })
            } else {
                errorMsg(res.data.Message, "Get Resources")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Resources")
        });
}

export const getApiUserRolesString = (user, pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/user/getModulesByRole`, { params: { sessionUser: sessionStorage.getItem('username'), pageSize: pageSize, pageNumber: pageNumber, role: user, allUserRole: true, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Message !== undefined) {
                dispatch({
                    type: COMP_PERM_STRING,
                    payload: res.data.Message
                })
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get User Roles")
        });

}

export const getApiUserRoles = (user) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/user/getModulesByRole`, { params: { pageSize: 1000, pageNumber: 0, role: user, allUserRole: false, "authorization": sessionStorage.getItem('header') != null ? sessionStorage.getItem('header') : '', sessionUser: sessionStorage.getItem('username') !== null ? sessionStorage.getItem('username') : '' } })
        .then((res) => {
            dispatch(loadingOff())

            if (res.data.Message !== undefined) {
                dispatch({
                    type: COMP_PERM,
                    payload: validationForRoles(res.data.Message)
                })
            }
        }).catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Get User Roles")
        });

}
export const changePassword = (data) => (dispatch, getState) => {
    axios
        .put(`${getState().data.apiUrl.address}/veras/user/updatePass`, {
            username: data.username,
            oldPassword: data.oldPassword,
            password: data.password,
        }, { params: { sessionUser: sessionStorage.getItem('username') } })
        .then((res) => {
            dispatch(loadingOff());
            if (res.data.Message !== undefined) {
                dispatch({
                    type: CHANGE_PASSWORD,
                    payload: res.data.Message,
                });
                infoMsg(res.data.Message)
            }
        })
        .catch((err) => {
            dispatch(loadingOff());
            errorMsg("Network Issues Please wait...", "Get User Roles");
        });

}

export const createUser = () => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/user/login`, {}, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data !== "") {
                dispatch({
                    type: API_KEY,
                    payload: res.data.Message
                })
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Key is not generate", "License Validation")
            // cogoToast.error("Key is not generate",{
            //     position: 'bottom-right'
            //   });
            // console.log(err);
        });

}

export const createApiUser = (form, location, pageSize, pageNumber) => (dispatch, getState) => {
    dispatch({
        type: LOADING_ON,
        payload: true,
    });
    axios
        .post(`${getState().data.apiUrl.address}/veras/user/add`, {}, { params: { ...form, sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())

            if (res.data.Error !== undefined) {
                errorMsg(res.data.Error, "Add User")
            } else {
                successMsg("Records saved", "Add User")
                dispatch({
                    type: VALID_USER,
                    payload: true
                })
                dispatch(getAllUser(pageSize, pageNumber));
            }
            if (location.pathname === '/validForm') {
                document.location.replace("/veras/#/")
            }
        }).catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Add User")
        });

}


export const addApiRole = (form, location, pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/role/add`, form, { params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error !== undefined) {
                errorMsg(res.data.Message, "Add Role")
            } else {
                dispatch(getAllRoles(pageSize, pageNumber))
                if (location.pathname === '/validForm') {
                    infoMsg("Please enter permission", "Add Role")
                } else {
                    successMsg("Role saved", "Add Role")
                }
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Add Role")
        });

}
export const updateApiRole = (form, location, pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .put(`${getState().data.apiUrl.address}/veras/role/update`, form, { params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error !== undefined) {
                errorMsg(res.data.Error, "Update Role")
            } else {
                dispatch(getAllRoles(pageSize, pageNumber))
                successMsg("Role saved", "Update Role")
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Update Role")
        });

}

export const getServerStats = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/serverstats/`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())

            if (res.data.Error !== undefined) {
                errorMsg(res.data.Error, "Server Stats")
            } else {
                dispatch({
                    type: SERVER_STATE,
                    payload: res.data
                })
            }
        }).catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Server Stats")
        });
}

export const updatePermissionUser = (form, id, pageSize, pageNumber) => (dispatch, getState) => {

    axios
        .post(`${getState().data.apiUrl.address}/veras/user/updateRoleResPermission`, {}, { params: { ...form, id: id, sessionUser: sessionStorage.getItem('username') !== undefined ? sessionStorage.getItem('username') : '', pageSize: pageSize, pageNumber: pageNumber, authorization: sessionStorage.getItem('header') !== undefined ? sessionStorage.getItem('header') : '' } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Error !== undefined) {
                errorMsg(res.data.Error, "Add Role Perm")
            } else {
                successMsg("Records saved", "Add Role Perm");
                dispatch(getApiUserRolesString(form.role, pageSize, pageNumber));
                dispatch(getUserRole(form.role, pageSize, pageNumber));
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Add Role Perm")
        });
}

export const getConnectionStatus = () => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/sysConfig/getConnection`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === 'OK') {
                dispatch({
                    type: CONNECTION_STATUS,
                    payload: res.data.connectionStatus,
                });
                dispatch({
                    type: GET_VERSION,
                    payload: res?.data.version,
                });
            } else {
                dispatch({
                    type: CONNECTION_STATUS,
                    payload: false,
                });
                dispatch({
                    type: GET_VERSION,
                    payload: 0,
                });
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            console.error(err);
            dispatch({
                type: CONNECTION_STATUS,
                payload: false,
            });
        });
};

export const getLiveJobList = (isActive, pageSize, pageIndex) => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/jobs/getJobs`, { params: { sessionUser: sessionStorage.getItem('username'), pageSize: pageSize, pageNumber: pageIndex, "getJob": isActive, "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (isActive === 'active') {
                if (res.data.Result === 'OK') {
                    dispatch({
                        type: GET_LIVE_JOB_LIST,
                        payload: res.data.Message,
                    });
                    dispatch({
                        type: GET_LIVE_JOB_TOTAL_RECORDS,
                        payload: res.data.totalRecords,
                    });
                } else {
                    dispatch({
                        type: GET_LIVE_JOB_LIST,
                        payload: [],
                    });
                }
            } else {
                if (res.data.Result === 'OK') {
                    dispatch({
                        type: GET_FINISH_JOB_LIST,
                        payload: res.data.Message,
                    });
                    dispatch({
                        type: GET_FINISH_JOB_TOTAL_RECORDS,
                        payload: res.data.totalRecords,
                    });
                } else {
                    dispatch({
                        type: GET_FINISH_JOB_LIST,
                        payload: [],
                    });
                }
            }
        })
        .catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Get Jobs")
            // cogoToast.error("Network Issues Please wait",{
            //     position: 'bottom-right'
            //   })
        });
}
export const getFetchQulityRecode = ({ logs, well, rigsId, bunit, dataprovider, version }) => (dispatch, getState) => {
    // const chartData = {
    //   startTime: "2024-01-19T12:00:00",
    //   endTime: "2024-01-19T14:00:00",
    //   pageSize: "101",
    //   pageNumber: "0",
    //   resultType: "aggregated",
    //   rigs: rigsId,
    //   logs: logs,
    //   wells: well,
    //   aswi: "disable",
    //   dqi: "enable",
    // };
    const chartData = {
        logs: logs,
        wells: well,
        bunit: bunit,
        dataprovider: dataprovider,
        authorization: sessionStorage.getItem('header'),
        rig: rigsId,
        version: version,
    };
    axios
        .post(`${getState().data.apiUrl.address}/veras/dq/fetchTemplateRecords`, {}, {
            params: {
                rig: chartData.rig,
                logs: chartData.logs,
                wells: chartData.wells,
                authorization: chartData.authorization,
                bunit: chartData.bunit,
                dataprovider: chartData.dataprovider,
                version: chartData.version,
                sessionUser: sessionStorage.getItem('username')
            }
        })
        .then((res) => {
            dispatch(loadingOff());

            if (res.data.data.Result === undefined) {
                dispatch({
                    type: GET_DATA_QUALITY_CHART_DATA,
                    payload: res.data.data.data,
                });
            } else {
                dispatch({
                    type: GET_DATA_QUALITY_CHART_DATA,
                    payload: [],
                });
            }
        })
        .catch((err) => {
            dispatch(loadingOff());
            errorMsg("Network Issues Please wait...");
        });
}
// export const getDataQuality = (row) => (dispatch, getState) => {

//     const data = new URLSearchParams();
//     // data.append('pageSize', 10);
//     // data.append('startTime', startPoint);
//     // data.append('endTime', endPoint);
//     // data.append('wells', wells);
//     // data.append('rigs', rigs);
//     // data.append('resultType', 'detailed');
//     // data.append('aswi', 'enable');
//     // data.append('dqi', 'enable');

//     axios.post(`http://192.168.2.104:8586/yhrest/dq/fetchRecords`, data,
//         {
//             headers: {
//                 'Authorization': 'Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=',
//                 'Content-Type': 'application/x-www-form-urlencoded',
//             }
//         }
//     )
//         .then(res => {
//             dispatch(loadingOff())
//             if (res.data) {
//                 dispatch({
//                     type: SET_DATA_QUALITY_TOTAL_RECORD,
//                     payload: res.data.data,
//                 });
//             }

//         })
//         .catch(error => {
//             dispatch(loadingOff())
//             console.error(error);
//         })
//         .finally(() => {
//             dispatch(loadingOff())
//         });
// };

// export const getJobList = () => (dispatch, getState) => {
//     axios.get(`${getState().data.apiUrl.address}/veras/sysConfig/getInfo`)
//         .then((res) => {
//             dispatch(loadingOff())
//             errorMsg("Network Issues Please wait...", "Get Jobs")
//             // cogoToast.error("Network Issues Please wait",{
//             //     position: 'bottom-right'
//             //   })
//         });
// }

export const getDataQualityTime = (asset_id, url) => (dispatch) => {
    axios.get(`http://192.168.3.41:8095/yhrest/well/get/SpudDate?WellID=${asset_id}`,
        {
            headers: {
                'authorization': "Basic UmlnQWRtaW46ODQ3NjUwOWM3MjE2NDY3NDgwMmU1NDcxZjM1OTE0MzU=",
                'Content-Type': "application/json",
            }, params: { sessionUser: sessionStorage.getItem('username') }
        }
    )
        .then(res => {
            if (res.data.Result === 'ERROR' || !res.data.Result) {
                dispatch({
                    type: GET_DATA_QUALITY_ASSET_ID,
                    payload: {},
                });
            }
            dispatch({
                type: GET_DATA_QUALITY_TIME,
                payload: res.data.data,
            });

        })
        .catch(error => {
            console.error(error);
        })
};

export const getDataQuality = (row) => (dispatch, getState) => {

    const data = new URLSearchParams();
    // data.append('pageSize', 10);
    // data.append('startTime', startPoint);
    // data.append('endTime', endPoint);
    // data.append('wells', wells);
    // data.append('rigs', rigs);
    // data.append('resultType', 'detailed');
    // data.append('aswi', 'enable');
    // data.append('dqi', 'enable');

    axios.post(`http://192.168.2.104:8586/yhrest/dq/fetchRecords`, data,
        {
            headers: {
                'Authorization': headers,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') }
        }
    )
        .then(res => {
            dispatch(loadingOff())
            if (res.data) {
                dispatch({
                    type: SET_DATA_QUALITY_TOTAL_RECORD,
                    payload: res.data.data,
                });
            }

        })
        .catch(error => {
            dispatch(loadingOff())
            console.error(error);
        })
        .finally(() => {
            dispatch(loadingOff())
        });
};

export const getJobList = () => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/sysConfig/getInfo`, { headers: { "Authorization": headers }, params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                dispatch({
                    type: JOB_LIST,
                    payload: res.data.Message,
                });
            } else {
                dispatch({
                    type: JOB_LIST,
                    payload: [],
                });
            }
        })
        .catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Get Jobs")
            // cogoToast.error("Network Issues Please wait",{
            //     position: 'bottom-right'
            //   })
        });

};

export const deleteSystemConfig = (form, pageSize, pageNumber) => (dispatch, getState) => {

    axios.delete(`${getState().data.apiUrl.address}/veras/sysConfig/deleteSysInfo`, { params: { id: form.id, sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK" && res.data.Error === undefined) {
                successMsg(res.data.Message, "System Config");
                dispatch(getAllSysConfig(pageSize, pageNumber));
                // dispatch(getAllSysConfig());
            }
        }).catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "System Config")
        });
}

// export const deleteRole = (deleteRow) => (dispatch, getState) => {
//     axios.delete(`${getState().data.apiUrl.address}/veras/role/delete`, {params: {roleName: deleteRow.roleName}})
//     .then((res) => {
//         dispatch(loadingOff())
//         if (res.data.Result === "OK") {
//             successMsg(res.data.Message)
//             dispatch(getAllRoles)
//         } else {
//             errorMsg(res.data.Message)
//         }
//     })
//     .catch((err) => {
//         dispatch(loadingOff())

//         errorMsg("Network Issues Please wait...", "Get Cluster Data")
//         // cogoToast.error("Network Issues Please wait",{
//         //     position: 'bottom-right'
//         //   })
//         // dispatch(createNotification("Failed to get Cluster data."));
//     });
// }

export const deleteRole = (deleteRow, pageSize, pageNumber) => (dispatch, getState) => {
    axios.delete(`${getState().data.apiUrl.address}/veras/role/delete`, { params: { roleName: deleteRow.roleName, id: deleteRow.id, sessionUser: '', "authorization": sessionStorage.getItem('header') } },)
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                successMsg(res.data.Message)
                dispatch(getUserRole('', pageSize, pageNumber))
                dispatch(getAllRoles(pageSize, pageNumber))
            } else {
                errorMsg(res.data.Message)
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Cluster Data")
            // cogoToast.error("Network Issues Please wait",{
            //     position: 'bottom-right'
            //   })
            // dispatch(createNotification("Failed to get Cluster data."));
        });
}

export const getClusterData = () => (dispatch, getState) => {
    axios.get(`${getState().data.apiUrl.address}/veras/cluster/get`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())

            if (res.data.Result === "OK") {
                dispatch({
                    type: CLUSTER_DATA,
                    payload: res.data?.Message,
                });
                dispatch({
                    type: CLUSTER_DATA_TEMPLATE,
                    payload: res.data,
                });
            }
        })
        .catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Get Cluster Data")
            // cogoToast.error("Network Issues Please wait",{
            //     position: 'bottom-right'
            //   })
            // dispatch(createNotification("Failed to get Cluster data."));
        });

};



export const getLogSnippet = (no_of_lines, notification = true) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/logs/read-logs`, { params: { lines: no_of_lines, sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())

            if (res.data.Result === "OK" && res.data?.Message.logs !== undefined) {
                dispatch({
                    type: LOG_SNIPPET,
                    payload: res.data?.Message.logs,
                });
                successMsg(`Successfully Fetched last ${no_of_lines} lines of logs.`, "Get Log Snippets")
            } else {
                errorMsg(res.data.Message.displayMsgs, "Get Log Snippets")
            }

        })
        .catch((err) => {
            dispatch(loadingOff())

            errorMsg("Network Issues Please wait...", "Get Log Snippets")
        });
};

export const updateSystemConfig = (form, pageSize, pageNumber) => (dispatch, getState) => {
    if (form.bUnit === "" && form.dataProvider === "" && form.isActive === "" && form.rig === "") {
        errorMsg("Network Issues Please wait...", "System Config");
    } else {
        axios
            .post(`${getState().data.apiUrl.address}/veras/sysConfig/set`, form, {
                params: {
                    sessionUser: sessionStorage.getItem("username"),
                    authorization: sessionStorage.getItem("header"),
                },
            })
            .then((res) => {
                dispatch(loadingOff());
                if (res.status === 200) {
                    //   if (res.data.Result === "isExist") {
                    //     infoMsg(res.data.Message);
                    //   }
                    if (res.data.Error !== undefined) {
                        errorMsg(res.data.Message, "System Config");
                    } else {
                        dispatch(getAllSysConfig(pageSize, pageNumber));
                        successMsg(res.data.Message, "System Config");
                    }
                }
                // if(location.pathname === '/validForm') {
                //     document.location.replace("/#/")
                // }
            })
            .catch((err) => {
                dispatch(loadingOff());
                errorMsg("Network Issues Please wait...", "System Config");
                // cogoToast.error("Network Issues Please wait...", {
                //     position: 'bottom-right'
                //   });
            });
    }
}

export const updateSystemConfigData = (form, pageSize, pageIndex) => (dispatch, getState) => {
    axios
        .put(`${getState().data.apiUrl.address}/veras/sysConfig/updateSysConfig`, form, {
            params: {
                sessionUser: sessionStorage.getItem("username") !== undefined ? sessionStorage.getItem("username") : '',
                authorization: sessionStorage.getItem("header") !== undefined ? sessionStorage.getItem("header") : '',
            },
        })
        .then((res) => {
            dispatch(loadingOff());
            if (res.status === 200) {
                if (res.data.Error !== undefined) {
                    errorMsg(res.data.Message, "System Config");
                } else {
                    dispatch(getAllSysConfig(pageSize, pageIndex));
                    successMsg(res.data.Message, "System Config");
                }
            }
        })
        .catch((err) => {
            dispatch(loadingOff());
            errorMsg("Network Issues Please wait...", "System Config");
        });
};

export const jobAction = (name, action, status) => (dispatch, getState) => {
    const bcApiUrl = getState().data.bcApiUrl.address;

    axios
        .post(`${getState().data.apiUrl.address}/veras/bc/job-action`, { job_name: name, job_action: action, url: bcApiUrl, job_status: status }, { headers: { Authorization: `Token ${getState().auth.token}` }, params: { sessionUser: sessionStorage.getItem('username') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.operation === "success") {
                if (action === "resume") {
                    successMsg(`Job Resumed Successfully.`, "Job Actions")
                } else if (action === "suspend") {
                    successMsg(`Job Suspended Successfully.`, "Job Actions")
                } else if (action === "restart") {
                    successMsg(`Job Restarted Successfully.`, "Job Actions")
                } else if (action === "cancel") {
                    successMsg(`Job Cancelled Successfully.`, "Job Actions")
                }
            } else if (res.data.operation === "ERROR") {
                errorMsg(res.data.displayMsgs, "Job Actions");
            } else {
                errorMsg("Job Operation Failed.", "Job Actions");
            }
            dispatch(getJobList());
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Job Actions");
        });
};


export const deployConfig = (data, operator) => (dispatch, getState) => {

    const deployConfigData = {
        configData: data,
        operator,
        url: getState().data.bcApiUrl.address
    };
    dispatch(loadingOn());

    if (operator === "dq") {
        const tempArrayInput = data.DataQualityOperator.inputDataStreams;
        const tempArrayOutput = data.DataQualityOperator.outputDataStreams;

        data.DataQualityOperator.inputDataStreams = {};
        tempArrayInput.forEach(({ keyName, ...channel }) => {
            data.DataQualityOperator.inputDataStreams[keyName] = channel;
        });
        data.DataQualityOperator.outputDataStreams = {};
        tempArrayOutput.forEach(({ keyName, ...channel }) => {
            data.DataQualityOperator.outputDataStreams[keyName] = channel;
        });
    } else if (operator === "oe_yh") {
        const tempArrayInput = data.WellOperationalOperator.inputDataStreams;
        const tempArrayOutput = data.WellOperationalOperator.outputDataStreams;
        const tempArrayFriction = data.WellOperationalOperator.frictionTestConfig;
        const tempArrayVelocity = data.WellOperationalOperator.velocityConfig;

        data.WellOperationalOperator.inputDataStreams = {};
        tempArrayInput.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.inputDataStreams[keyName] = channel;
        });
        data.WellOperationalOperator.outputDataStreams = {};
        tempArrayOutput.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.outputDataStreams[keyName] = channel;
        });
        data.WellOperationalOperator.frictionTestConfig = {};
        tempArrayFriction.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.frictionTestConfig[keyName] = channel;
        });
        data.WellOperationalOperator.velocityConfig = {};
        tempArrayVelocity.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.velocityConfig[keyName] = channel;
        });
    } else if (operator === "oe_csv") {
        const tempArrayInput = data.WellOperationalOperator.inputDataStreams;
        const tempArrayOutput = data.WellOperationalOperator.outputDataStreams;
        const tempArrayFriction = data.WellOperationalOperator.frictionTestConfig;
        const tempArrayVelocity = data.WellOperationalOperator.velocityConfig;

        data.WellOperationalOperator.inputDataStreams = {};
        tempArrayInput.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.inputDataStreams[keyName] = channel;
        });
        data.WellOperationalOperator.outputDataStreams = {};
        tempArrayOutput.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.outputDataStreams[keyName] = channel;
        });
        data.WellOperationalOperator.frictionTestConfig = {};
        tempArrayFriction.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.frictionTestConfig[keyName] = channel;
        });
        data.WellOperationalOperator.velocityConfig = {};
        tempArrayVelocity.forEach(({ keyName, ...channel }) => {
            data.WellOperationalOperator.velocityConfig[keyName] = channel;
        });
    } else if (operator === "py") {
        const tempArrayInput = data.PyBridgeOperator.inputDataStreams;
        const tempArrayOutput = data.PyBridgeOperator.outputDataStreams;

        data.PyBridgeOperator.inputDataStreams = {};
        tempArrayInput.forEach(({ keyName, ...channel }) => {
            data.PyBridgeOperator.inputDataStreams[keyName] = channel;
        });
        data.PyBridgeOperator.outputDataStreams = {};
        tempArrayOutput.forEach(({ keyName, ...channel }) => {
            data.PyBridgeOperator.outputDataStreams[keyName] = channel;
        });
    } else if (operator === "ao") {
        const tempArrayInput = data.ArithmeticProgressionOperator.inputDataStreams;
        const tempArrayOutput = data.ArithmeticProgressionOperator.outputDataStreams;

        data.ArithmeticProgressionOperator.inputDataStreams = {};
        tempArrayInput.forEach(({ keyName, ...channel }) => {
            data.ArithmeticProgressionOperator.inputDataStreams[keyName] = channel;
        });
        data.ArithmeticProgressionOperator.outputDataStreams = {};
        tempArrayOutput.forEach(({ keyName, ...channel }) => {
            data.ArithmeticProgressionOperator.outputDataStreams[keyName] = channel;
        });
    }

    axios
        .post(`${getState().data.apiUrl.address}/veras/bc/deploy-config`, { ...deployConfigData }, { headers: { Authorization: `Token ${getState().auth.token}` }, params: { sessionUser: sessionStorage.getItem('username') } })
        .then((res) => {
            if (res.data.operation === "success") {
                dispatch(loadingOff());
                dispatch({
                    type: REDIRECT,
                    payload: true,
                });
                if (operator === "dq") {
                    dispatch({
                        type: SELECT_SCHEMA,
                        payload: dqSchema,
                    });
                    dispatch({
                        type: SELECT_UI_SCHEMA,
                        payload: dqUiSchema,
                    });
                    dispatch({
                        type: CONFIG_CONTENT,
                        payload: dqData,
                    });
                } else if (operator === "oe_yh") {
                    dispatch({
                        type: SELECT_SCHEMA,
                        payload: oeYhSchema,
                    });
                    dispatch({
                        type: SELECT_UI_SCHEMA,
                        payload: oeYhUiSchema,
                    });
                    dispatch({
                        type: CONFIG_CONTENT,
                        payload: oeYhData,
                    });
                } else if (operator === "oe_csv") {
                    dispatch({
                        type: SELECT_SCHEMA,
                        payload: oeCsvSchema,
                    });
                    dispatch({
                        type: SELECT_UI_SCHEMA,
                        payload: oeCsvUiSchema,
                    });
                    dispatch({
                        type: CONFIG_CONTENT,
                        payload: oeCsvData,
                    });
                } else if (operator === "py") {
                    dispatch({
                        type: SELECT_SCHEMA,
                        payload: pySchema,
                    });
                    dispatch({
                        type: SELECT_UI_SCHEMA,
                        payload: pyUiSchema,
                    });
                    dispatch({
                        type: CONFIG_CONTENT,
                        payload: pyData,
                    });
                }

            } else if (res.data.operation === "ERROR") {
                errorMsg(res.data.displayMsgs, "Job Deploy");
                dispatch(loadingOff());
            }
        })
        .catch((err) => {
            console.error(err);
            dispatch(loadingOff());
            errorMsg("Deployment of config is failed. Please check log.", "Job Deploy");
        });
};

export const editConfig = (name) => (dispatch, getState) => {
    // dispatch(loadingOn());

    const sampleData = {
        dq: dqSchema,
        oe_yh: oeYhSchema,
        oe_csv: oeCsvSchema,
        py: pySchema,
        ao: aoSchema,
    };

    const sampleUiSchema = {
        dq: dqUiSchema,
        oe_yh: oeYhUiSchema,
        oe_csv: oeCsvUiSchema,
        py: pyUiSchema,
        ao: aoUiSchema,
    };

    axios
        .post(`${getState().data.apiUrl.address}/veras/bc/edit-config`, { job_name: name }, { headers: { Authorization: `Token ${getState().auth.token}` }, params: { sessionUser: sessionStorage.getItem('username') } })
        .then((res) => {
            if (res.data.operation === "success") {
                const config = res.data.config;
                const operator = res.data.operator === "DataQualityOperator" ? "dq" : res.data.operator === "WellOperationalOperator" ? "oe_yh" : res.data.operator === "ArithmeticProgressionOperator" ? "ao" : "py";

                if (operator === "dq") {
                    config.DataQualityOperator.inputDataStreams = Object.keys(config.DataQualityOperator.inputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.DataQualityOperator.inputDataStreams[keyName],
                    }));
                    config.DataQualityOperator.outputDataStreams = Object.keys(config.DataQualityOperator.outputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.DataQualityOperator.outputDataStreams[keyName],
                    }));
                } else if (operator === "oe_yh") {
                    config.WellOperationalOperator.inputDataStreams = Object.keys(config.WellOperationalOperator.inputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.WellOperationalOperator.inputDataStreams[keyName],
                    }));

                    config.WellOperationalOperator.outputDataStreams = Object.keys(config.WellOperationalOperator.outputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.WellOperationalOperator.outputDataStreams[keyName],
                    }));

                    config.WellOperationalOperator.frictionTestConfig = Object.keys(config.WellOperationalOperator.frictionTestConfig).map((keyName) => ({
                        keyName,
                        ...config.WellOperationalOperator.frictionTestConfig[keyName],
                    }));

                    config.WellOperationalOperator.velocityConfig = Object.keys(config.WellOperationalOperator.velocityConfig).map((keyName) => ({
                        keyName,
                        ...config.WellOperationalOperator.velocityConfig[keyName],
                    }));
                } else if (operator === "py") {
                    config.PyBridgeOperator.inputDataStreams = Object.keys(config.PyBridgeOperator.inputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.PyBridgeOperator.inputDataStreams[keyName],
                    }));

                    config.PyBridgeOperator.outputDataStreams = Object.keys(config.PyBridgeOperator.outputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.PyBridgeOperator.outputDataStreams[keyName],
                    }));
                } else if (operator === "ao") {
                    config.PyBridgeOperator.inputDataStreams = Object.keys(config.PyBridgeOperator.inputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.PyBridgeOperator.inputDataStreams[keyName],
                    }));

                    config.PyBridgeOperator.outputDataStreams = Object.keys(config.PyBridgeOperator.outputDataStreams).map((keyName) => ({
                        keyName,
                        ...config.PyBridgeOperator.outputDataStreams[keyName],
                    }));
                }
                dispatch({
                    type: CONFIG_CONTENT,
                    payload: config,
                });
                dispatch({
                    type: SET_OPERATOR,
                    payload: operator,
                });
                dispatch({
                    type: SELECT_UI_SCHEMA,
                    payload: sampleUiSchema[operator],
                });
                dispatch({
                    type: SELECT_SCHEMA,
                    payload: sampleData[operator],
                });
                dispatch(loadingOff());
                window.location = "/configForm";
            } else {
                dispatch(loadingOff());
                errorMsg(res.data.message, "Configuration Form");
            }
        })
        .catch((err) => {
            dispatch(loadingOff());
            errorMsg("Network Issues Please wait...", "Configuration Form");
        });
};

export const updateApiUser = (form, pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .put(`${getState().data.apiUrl.address}/veras/user/update`, form, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                successMsg("Successfully Update", "Manage User")
                dispatch(getAllUser(pageSize, pageNumber))
                dispatch(getUserByUserName(form.username));
            } else {
                errorMsg("Not Update...", "Manage User");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Manage User");
        });

}

export const getUserByUserName = (username) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/user/getUser`, { params: { username: username, sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                dispatch({
                    type: USER_DATA,
                    payload: res.data.Message
                })
            } else {
                errorMsg("No User Some Problem... ", "Manage User");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Manage User");
        });

}

export const getLicenseKey = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/licence/genrateKey`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                dispatch({
                    type: KEY_GENERATE,
                    payload: res.data.Message
                })
            } else {
                errorMsg("Failed to get license key", "Get License Key");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get License Key");
        });

}

export const getUserValid = () => (dispatch, getState) => {
    // axios
    //     .get(`${getState().data.apiUrl.address}/veras/user/getCountUser`, { params: {sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
    //     .then((res) => {
    //         dispatch(loadingOff())
    //         if (res.data.Result !== undefined) {
    //             dispatch({
    //                 type: VALID_USER,
    //                 payload: false
    //             })
    //             document.location.replace("/veras/#/validForm")
    //         }
    //     })
    //     .catch((err) => {
    //         dispatch(loadingOff())
    //         errorMsg("Network Issues Please wait...", "Get User Valid");
    //     });

}

export const getConfigFile = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/sysConfig/getCount`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === 'OK') {
                dispatch({
                    type: IS_CONFIG_USER,
                    payload: res.data.Message
                })
                if (!res.data.Message) {
                    errorMsg("System Configuration is pending...", "Get Config Form");
                    document.location.replace("/veras/#/validForm")
                }
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Config Form");
        });

}

export const getValidateKey = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/licence/validateKey`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": "" } })
        .then((res) => {
            console.log('res validkey ', res)
            dispatch(loadingOff())
            if (res.data.Result !== undefined) {
                dispatch({
                    type: IS_VALID_KEY,
                    payload: res.data.Message
                })
                // dispatch({
                //     type: VALID_USER,
                //     payload: res.data.isUserValid
                // })
                dispatch({
                    type: IS_CONFIG_USER,
                    payload: res.data.isConfigUser
                })
                if (!res.data.Message) {
                    errorMsg(res.data.Error, "Get Validate Key");
                    document.location.replace("/veras/#/validForm")
                }
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Validate Key");
        });

}

export const getValid = (fileUpload) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/licence/keyValidate`, fileUpload, { headers: { 'Content-Type': 'multipart/form-data' }, params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result !== undefined && res.data.Message) {
                dispatch({
                    type: IS_VALID_KEY,
                    payload: res.data.Message
                })
                successMsg("License key saved!")
                dispatch(getAllLicenseData({ pageSize: 10, pageNumber: 1, columnName: "", orderBy: "desc" }))
                // dispatch({
                //     type: VALID_USER,
                //     payload: false
                // })
                // return true;
                // document.location.replace("/#/")
            } else {
                errorMsg(res.data.Error, "Get Validate");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Validate");
            // console.log(err);
            // cogoToast.error("Something went wrong.",{
            //     position: 'bottom-right'
            //   });
        });

}

export const getUserRole = (roleName, pageSize, pageIndex) => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/resource/getModulesByRole`, { params: { sessionUser: sessionStorage.getItem('username'), pageSize: pageSize, pageNumber: pageIndex, role: roleName, authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result !== undefined) {
                dispatch({
                    type: USER_ROLE_LIST,
                    payload: res.data.Message
                })
                dispatch({
                    type: VUSER_ROLE_LIST_TOTALRECORDS,
                    payload: res.data.totalRecords
                })
            } else {
                errorMsg(res.data.Message, "Get User Role ");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Validate");
            // console.log(err);
            // cogoToast.error("Something went wrong.",{
            //     position: 'bottom-right'
            //   });
        });

}

export const getLogList = (LogFolderPath = "") => (dispatch, getState) => {
    const bcApiUrl = getState().data.bcApiUrl.address;

    axios
        .post(`${getState().data.apiUrl.address}/veras/bc/get-log-list`, { url: bcApiUrl, LogFolderPath }, { headers: { Authorization: `Token ${getState().auth.token}` }, params: { sessionUser: sessionStorage.getItem('username') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.operation === "success") {
                dispatch({
                    type: LOG_FILES,
                    payload: res.data.logs
                })
            } else {
                errorMsg("Failed get log list.", "Get Log List");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Log List");
        });

};

export const getLogLevel = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/logs/getLogLevel`, { params: { sessionUser: sessionStorage.getItem('username'), "authorization": sessionStorage.getItem('header') } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                dispatch({
                    type: SET_LOG_LEVEL,
                    payload: res.data.Message
                })
            } else {
                errorMsg("Failed get current Log Level.", "Get Log Level");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Log Level");
        });

}

export const updateLogLevel = (logLevel) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/logs/updateLogLevel`, {}, { params: { sessionUser: sessionStorage.getItem('username'), logLevel, authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.Result === "OK") {
                dispatch({
                    type: SET_LOG_LEVEL,
                    payload: logLevel
                })
            } else {
                errorMsg("Failed get current Log Level.", "Save Log Level");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Save Log Level");
        });
}

export const getNodeInfo = (pageSize, pageNumber) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/nodeInfo/get`, { "pageNumber": pageNumber, "pageSize": pageSize, "username": sessionStorage.getItem('username') }, { params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.status === "Success" && res.data.data.Result === "OK") {
                dispatch({
                    type: GET_NODE_INFO_DATA,
                    payload: res.data.data.data
                })
                dispatch({
                    type: GET_TOTAL_RECORD_NODE_INFO,
                    payload: res.data.data.totalRecords
                })
            } else {
                errorMsg("Failed get node info Level.", "Node Info");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Node Info");
        });
}

export const addNodeInfo = (data) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/nodeInfo/add`, data, { params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.status === "Success" && res.data.data.Result === "OK") {
                dispatch({
                    type: IS_SUCCESS,
                    payload: true
                })
                dispatch(getNodeInfo(10, 0))
                successMsg("Succefully update")
            } else {
                errorMsg(res.data.data.Message, "Node Info");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Node Info");
        });
}

export const updateNodeInfo = (data) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/nodeInfo/update`, data, { params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.status === "Success" && res.data.data.Result === "OK") {
                dispatch(getNodeInfo(10, 0))
                successMsg("Succefully update")
                dispatch({
                    type: IS_SUCCESS,
                    payload: true
                })
            } else {
                errorMsg(res.data.data.Message, "Node Info");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Node Info");
        });
}

export const deleteNodeInfo = (nodeInfo) => (dispatch, getState) => {
    axios
        .post(`${getState().data.apiUrl.address}/veras/nodeInfo/delete`, nodeInfo, { params: { sessionUser: sessionStorage.getItem('username'), authorization: headers } })
        .then((res) => {
            dispatch(loadingOff())
            if (res.data.status === "Success" && res.data.data.Result === "OK") {
                dispatch(getNodeInfo(10, 0))
            } else {
                errorMsg(res.data.data.Message, "Node Info");
            }
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Node Info");
        });
}


/**    --------------------- Third Party API Through Data Fetch -------------------------------   */

export const getSystemProvider = () => (dispatch, getState) => {
    axios
        .get(`${getState().data.apiUrl.address}/veras/sysConfig/getSysConfig`, { params: { sessionUser: sessionStorage.getItem('username') !== undefined ? sessionStorage.getItem('username') : '', authorization: sessionStorage.getItem('header') !== null ? sessionStorage.getItem('header') : '' } })
        .then((res) => {
            if (res.data.Result === "OK") {
                if (Array.isArray(res.data.Message.rigs)) {
                    dispatch({
                        type: GET_DP_RIGS_LIST,
                        payload: res.data.Message.rigs
                    })
                } else {
                    errorMsg(res.data.Message.rigs);
                }

                if (Array.isArray(res.data.Message.dataProv)) {
                    dispatch({
                        type: GET_DP_DP_LIST,
                        payload: res.data.Message.dataProv
                    })
                } else {
                    errorMsg(res.data.Message.dataProv);
                }

                if (Array.isArray(res.data.Message.bUnit)) {
                    dispatch({
                        type: GET_DP_BUNIT_LIST,
                        payload: res.data.Message.bUnit
                    })
                } else {
                    errorMsg(res.data.Message.bUnit);
                }
                if (Array.isArray(res.data.Message.nodeInfo)) {
                    dispatch({
                        type: GET_NODE_INFO_LIST,
                        payload: res.data.Message.nodeInfo
                    })
                } else {
                    errorMsg(res.data.Message.nodeInfo);
                }
            } else {
                errorMsg(res.data.MESSAGE, "Get User Role ");
            }
            dispatch(loadingOff())
        })
        .catch((err) => {
            dispatch(loadingOff())
            errorMsg("Network Issues Please wait...", "Get Validate");
            // console.log(err);
            // cogoToast.error("Something went wrong.",{
            //     position: 'bottom-right'
            //   });
        });
}

// export const getSysProvRigs = (sessionId) => (dispatch, getState) => {
//     const formData = new URLSearchParams();
//     var setcontent = new FormData()
//     //console.log(sessionId)
//     axios.defaults.withCredentials = 'true';
//     // axios.defaults.crossDomain = 'true';
//     // axios.defaults.headers.post['Content-Type'] = 'application/json';
//     axios.defaults.headers.post['withCredentials'] = 'true';
//     formData.append('session-id', sessionId);
//     axios
//         .post(`http://192.168.2.26:9998/rest/rig`, formData, {
//             withCredentials: true,
//             headers: {
//                 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
//                 'Cookie': `JSESSIONID=${sessionId}.node0; Path=/rest;`,  // Assuming sessionId is a valid session ID
//             },
//             //xsrfCookieName: `JSESSIONID=${sessionId}.node0`
//         })
//         .then((res) => {
//             console.log(res)
//             if (res.data.STATUS === "SUCCESS") {
//                 dispatch({
//                     type: GET_DP_RIGS_LIST,
//                     payload: res.data.DATA
//                 })
//             } else {
//                 errorMsg(res.data.MESSAGE, "Get User Role ");
//             }
//         })
//         .catch((err) => {
//             errorMsg("Network Issues Please wait...", "Save Log Level");
//             // console.log(err);
//             // cogoToast.error("Something went wrong.",{
//             //     position: 'bottom-right'
//             //   });
//         });
// }

// export const getSysProvDataProv = (sessionId) => (dispatch, getState) => {
//     const formData = new URLSearchParams();
//     formData.append('session-id', sessionId);
//     document.cookie = `JSESSIONID=${sessionId}.node0`
//     // axios.defaults.withCredentials = 'true';
//     // axios.defaults.crossDomain = 'true';
//     // axios.defaults.headers.post['Content-Type'] = 'application/json';
//     // axios.defaults.headers.post['withCredentials'] = 'true';
//     axios
//         .post(`http://192.168.2.26:9998/rest/VrsTemplate/getDataProvider`, formData, {
//             withCredentials: true,
//             headers: {
//                 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
//             }
//         })
//         .then((res) => {
//             dispatch(loadingOff())
//             if (res.data.STATUS === "SUCCESS") {
//                 dispatch({
//                     type: GET_DP_DP_LIST,
//                     payload: res.data.DATA
//                 })
//             } else {
//                 errorMsg(res.data.MESSAGE, "Get User Role ");
//             }
//         })
//         .catch((err) => {
//             dispatch(loadingOff())
//             errorMsg("Network Issues Please wait...", "Get Validate");
//             // console.log(err);
//             // cogoToast.error("Something went wrong.",{
//             //     position: 'bottom-right'
//             //   });
//         });
// }

// export const getSysProvBusinessUnit = (sessionId) => (dispatch, getState) => {
//     const formData = new URLSearchParams();
//     formData.append('session-id', sessionId);
//     document.cookie = `JSESSIONID=${sessionId}.node0`
//     // axios.defaults.withCredentials = 'true';
//     // axios.defaults.crossDomain = 'true';
//     // axios.defaults.headers.post['Content-Type'] = 'application/json';
//     // axios.defaults.headers.post['withCredentials'] = 'true';
//     axios
//         .post(`http://192.168.2.26:9998/rest/VrsTemplate/getBusinessUnit`, formData, {
//             withCredentials: true,
//             headers: {
//                 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
//             }
//         })
//         .then((res) => {
//             dispatch(loadingOff())
//             if (res.data.STATUS === "SUCCESS") {
//                 dispatch({
//                     type: GET_DP_BUNIT_LIST,
//                     payload: res.data.DATA
//                 })
//             } else {
//                 errorMsg(res.data.MESSAGE, "Get User Role ");
//             }
//         })
//         .catch((err) => {
//             dispatch(loadingOff())
//             errorMsg("Network Issues Please wait...", "Get Validate");
//             // console.log(err);
//             // cogoToast.error("Something went wrong.",{
//             //     position: 'bottom-right'
//             //   });
//         });
// }
